import { Produktlinie, UebergreifendItem, ZusatzoptionItem } from '@ps20-frontend/frontend-models';
import { getSelectedProduktlinie } from '@ps20-frontend/preis-lib';
import { IAppState } from '../../../store/appState';
import {
  ZusatzoptionenNameRSEnum,
  ZusatzoptionItemRS,
} from '../../../store/models/zusatzoptionenRS.model';
import { BausteinnameEnum } from '../../../store/models/bausteinname.model';

export const selectProduktlinien = (state: IAppState): Array<Produktlinie> =>
  state.produkt?.produktlinien || [];

export const selectUebergreifendeLeistungen = (state: IAppState): Array<UebergreifendItem> =>
  state.produkt?.uebergreifend || [];

export const selectSelectedProduktlinie = (state: IAppState): Produktlinie =>
  getSelectedProduktlinie(state.produkt);

export const selectSelectedProduktlinieIndex = (state: IAppState): number => {
  return selectProduktlinien(state).findIndex(produktlinie => produktlinie.selected);
};

const selectSelectedProductZusatzoptionItems = (state: IAppState): ZusatzoptionItem[] =>
  getSelectedProduktlinie(state.produkt)?.zusatzoptionen || [];

export const selectSelectedZusatzoptionItems = (state: IAppState): Array<ZusatzoptionItem> => {
  return selectSelectedProductZusatzoptionItems(state).filter(elem => elem.isSelected);
};

export const selectZusatzoptionItems = (state: IAppState): Array<ZusatzoptionItemRS> => {
  const zusatzoptionen = selectSelectedProductZusatzoptionItems(state);
  return zusatzoptionen.map(zusatzoption => ({
    ...zusatzoption,
    disabled:
      zusatzoption.name === ZusatzoptionenNameRSEnum.STRAFRECHTSSCHUTZ &&
      isStrafschutzDisabled(getSelectedProduktlinie(state.produkt)),
  }));
};

export function isStrafschutzDisabled(produktlinie: Produktlinie): boolean {
  const berufBaustein = produktlinie?.gefahren.find(
    gefahr => gefahr.name === BausteinnameEnum.BERUF,
  );
  return berufBaustein == null || berufBaustein.isSelected === false;
}

export type SelectZusatzoptionItemsReturnType = ReturnType<typeof selectZusatzoptionItems>;
